<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <!-- Back to fleet link -->
      <common-back-to-page-link text="Back to fleet"></common-back-to-page-link>

      <!-- Progress stepper -->
      <div class="stepper-container mt-3 mb-2">
        <div class="stepper">
          <ng-container *ngFor="let step of steps; let i = index">
            <div
              class="stepper-item"
              [class.active]="getStepStatus(step) === 'active'"
              [class.completed]="getStepStatus(step) === 'completed'"
              [class.clickable]="canNavigateTo(step)"
              [class.disabled]="!canNavigateTo(step)"
              (click)="canNavigateTo(step) && goToStep(step)"
            >
              <div class="stepper-number">{{ step.stepNumber }}</div>
              <span class="stepper-label">{{ step.label }}</span>
            </div>
            <div
              *ngIf="i < steps.length - 1"
              class="stepper-line"
              [class.completed]="getStepStatus(step) === 'completed'"
            ></div>
          </ng-container>
        </div>
      </div>

      <!-- Main card container -->
      <div class="card my-3">
        <div class="card-body">
          <!-- Step Content -->
          <div class="step-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
